import styles from "./dashboard.module.css";
import { GridLoader } from "react-spinners";
import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ClipLoader } from 'react-spinners';
import { convert } from "../utils/dateConverter";
import { fetchAndRenderAllData, API_URL } from '../utils/fatch'

export function AllTrips() {
    const navigate = useNavigate();
    const [allTrips, setAllTrips] = useState([]);
    const [historySummary, setHistorySummary] = useState({ isSummary: false, text: '' });
    const [summaryLoading, setSummaryLoading] = useState(false);
    const [tripHovered, setTripHovered] = useState({ id: null });
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortBy, setSortBy] = useState('recent');
    const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

    const tripCountText = allTrips.length > 0
        ? (searchQuery.trim()
            ? `${visibleTrips.length} of ${allTrips.length}`
            : `${allTrips.length} ${allTrips.length === 1 ? 'trip' : 'trips'}`)
        : '';

    const visibleTrips = useMemo(() => {
        const query = searchQuery.trim().toLowerCase();

        const matching = allTrips.filter((trip) => {
            if (!query) return true;

            const haystack = [trip.trip_name, trip.destination, trip.city, trip.state, trip.country]
                .filter(Boolean)
                .join(' ')
                .toLowerCase();

            return haystack.includes(query);
        });

        const sorted = [...matching];

        if (sortBy === 'recent') {
            sorted.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        } else if (sortBy === 'oldest') {
            sorted.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
        } else if (sortBy === 'spent') {
            sorted.sort((a, b) => Number(b.total_spent) - Number(a.total_spent));
        } else if (sortBy === 'name') {
            sorted.sort((a, b) => (a.trip_name || '').localeCompare(b.trip_name || ''));
        }

        return sorted;
    }, [allTrips, searchQuery, sortBy]);

    async function fetchAndRenderData() {
        setLoading(true);
        const { data, status } = await fetchAndRenderAllData();
        if (status === 401) {
            navigate('/login');
            return;
        }
        if (status !== 404) {
            setAllTrips(data.trips);
        }
        setLoading(false);
    }

    const generateSummary = async () => {
        const haha = false;
        if (!haha) return;
        try {
            setSummaryLoading(true);
            const response = await fetch(`${API_URL}/ai/historySummary`, {
                method: 'GET',
                credentials: 'include',
            });
            if (!response.ok) {
                console.log(response.status);
            }
            const data = await response.json();
            setHistorySummary({ isSummary: true, text: data.output });
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setSummaryLoading(false);
        }
    }

    useEffect(() => {
        fetchAndRenderData();
        generateSummary();
    }, [])

    return (<>
        {loading && (
            <div className={styles.loadingIndicator}>
                <GridLoader color="#0ea5e9" size={18} />
            </div>
        )}

        {!loading && (
            <>
              {/* ===== HERO BANNER ===== */}
                <div className={styles.heroBanner}>
                    <div className={styles.heroTop}>
                        <div className={styles.heroMain}>
                            <div className={styles.heroTitleRow}>
                                <div className={styles.heroText}>
                                    <h2>Your Trips ✈️</h2>
                                    <p>All your adventures in one place</p>
                                </div>

                                {allTrips.length > 0 && (
                                    <div className={styles.mobileTripCountBadge}>
                                        <span></span>
                                        {tripCountText}
                                    </div>
                                )}
                            </div>

                           
                        </div>

                         {allTrips.length > 0 && (
                                <div className={styles.tripCountBadge}>
                                    <span></span>
                                    {tripCountText}
                                </div>
                            )}

                        <Link to="/new_trip" className={styles.heroNewTripBtn}>
                            <i className="fa-solid fa-plus"></i>
                            New Trip
                        </Link>
                    </div>
                </div>
                 <div className={styles.tripContent}>

              

                {/* ===== EMPTY STATE ===== */}
                {!allTrips.length && (
                    <div className={styles.noTrips}>
                        <img src="/noTrips3.png" alt="no trips" style={{ width: '35vw', height: 'auto', maxWidth: '240px' }} />
                        <h3>No journeys yet.<br />Time to plan your first adventure! 🏝️</h3>
                        <Link to="/new_trip" className={styles.noTripsBtn}>
                            ✈️ Start a New Trip
                        </Link>
                    </div>
                )}

                {/* ===== SEARCH + SORT ===== */}
                {allTrips.length > 0 && (
                    <>
                        <button
                            type="button"
                            className={styles.mobileFilterToggle}
                            onClick={() => setMobileFiltersOpen((prev) => !prev)}
                            aria-label="Toggle search and filters"
                        >
                            <i className="fa-solid fa-filter"></i>
                            {mobileFiltersOpen ? 'Hide filters' : 'Search & filters'}
                        </button>

                        <div className={`${styles.toolbar} ${mobileFiltersOpen ? styles.toolbarVisibleMobile : ''}`}>
                            <div className={styles.searchWrap}>
                                <i className={`fa-solid fa-magnifying-glass ${styles.searchIcon}`}></i>
                                <input
                                    type="search"
                                    className={styles.searchInput}
                                    placeholder="Search by name or destination"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                {searchQuery && (
                                    <button
                                        type="button"
                                        className={styles.searchClear}
                                        onClick={() => setSearchQuery('')}
                                        aria-label="Clear search"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>

                            <label className={styles.sortWrap}>
                                <span className={styles.sortLabel}>Sort</span>
                                <select
                                    className={styles.sortSelect}
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="recent">Newest first</option>
                                    <option value="oldest">Oldest first</option>
                                    <option value="spent">Most spent</option>
                                    <option value="name">Name (A–Z)</option>
                                </select>
                            </label>
                        </div>
                    </>
                )}

                {/* ===== NOTHING MATCHED ===== */}
                {allTrips.length > 0 && visibleTrips.length === 0 && (
                    <div className={styles.noResults}>
                        <p>No trips match &ldquo;{searchQuery}&rdquo;.</p>
                        <button type="button" className={styles.noResultsBtn} onClick={() => setSearchQuery('')}>
                            Clear search
                        </button>
                    </div>
                )}

                {/* ===== TRIPS GRID ===== */}
                {visibleTrips.length > 0 && (
                    <div className={styles.summaryAllTripsContainer}>

                        {summaryLoading && (
                            <div style={{ textAlign: 'center', padding: 20 }}><ClipLoader size={20} /></div>
                        )}

                        {historySummary.isSummary && (
                            <div style={{ marginBottom: 16, padding: '14px 18px', background: '#fff', borderRadius: 16, border: '1px solid #f1f5f9' }}>
                                <p style={{ textAlign: "left", whiteSpace: "pre-wrap", color: '#374151', lineHeight: 1.6, margin: 0, fontSize: 14 }}>{historySummary.text}</p>
                            </div>
                        )}

                        <section className={styles.AllTripsContainer}>
                            {visibleTrips.map((trip) => {
                                const startAt = convert(trip.start_date);
                                const endAt = convert(trip.end_date);

                                const dateStr = startAt.year === endAt.year
                                    ? startAt.month === endAt.month
                                        ? startAt.month + ' ' + startAt.year
                                        : `${startAt.month} – ${endAt.month} ${endAt.year}`
                                    : `${startAt.fullDate} – ${endAt.fullDate}`;

                                return (
                                    <Link
                                        to={`/trip/${trip.id}`}
                                        key={trip.id}
                                        onMouseEnter={() => setTripHovered({ id: trip.id })}
                                        onMouseLeave={() => setTripHovered({ id: null })}
                                        className={styles.tripItem}
                                    >
                                        {/* Image on top */}
                                        <div
                                            className={styles.tripImage}
                                            style={{ backgroundImage: `url(${trip.img ? trip.img : './1.jpg'})` }}
                                        >
                                            {tripHovered.id === trip.id && (
                                                <div className={styles.tripImageOverlay}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                                                        <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
                                                    </svg>
                                                </div>
                                            )}

                                            {trip.trip_role !== 'owner' && (
                                                <span className={styles.sharedBadge}>Shared with you</span>
                                            )}

                                            {/* Sits inside the card's Link, so it has to stop the navigation itself */}
                                            <button
                                                type="button"
                                                className={styles.shareBtn}
                                                title="Share this trip"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    navigate(`/share_trip/${trip.id}`);
                                                }}
                                            >
                                                <i className="fa-solid fa-user-plus"></i>
                                                {trip.member_count > 1 && <span>{trip.member_count}</span>}
                                            </button>
                                        </div>

                                        {/* Info below */}
                                        <div className={styles.eachTripInfo}>
                                            <h3 className={styles.tripName}>{trip.trip_name}</h3>
                                            <p className={styles.tripDate}>
                                                <i className="fa-regular fa-calendar"></i>
                                                {dateStr}
                                            </p>
                                            <div className={styles.tripSpent}>
                                                <div>
                                                    <span className={styles.spentAmount}>${Number(trip.total_spent).toFixed(2)}</span>
                                                    <span className={styles.spentLabel}> spent</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })}
                        </section>
                    </div>
                )}
            </div>
            </>
           
        )}
    </>);
}
